import { render, staticRenderFns } from "./FaqSearch.vue?vue&type=template&id=5ef2f0b4&scoped=true&lang=pug&"
import script from "./FaqSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./FaqSearch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FaqSearch.scss?vue&type=style&index=0&id=5ef2f0b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef2f0b4",
  null
  
)

export default component.exports